import React from 'react';

// DO NOT EDIT - THIS FILE IS GENERATED
/* eslint-disable */

var musicAndArtsIcon = /*#__PURE__*/React.createElement("svg", {
  height: "24",
  width: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("g", {
  fill: "currentColor",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16.208 17.487h7.562c0-.842-.684-1.524-1.527-1.524H3.383V2h17.216v10.997c0 .806.683 1.46 1.526 1.46V1.016a.487.487 0 0 0-.497-.476H2.364a.496.496 0 0 0-.507.485V15.97A1.163 1.163 0 0 0 .73 17.13v.356h7.216l-3.983 5.128c-.149.191-.077.444.162.565l.428.216c.24.12.554.061.704-.132l4.488-5.777h1.569v5.524h1.526v-5.524h1.569l4.489 5.78c.148.19.462.25.7.13l.431-.218c.239-.12.311-.372.162-.563l-3.983-5.13Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.453 3.307a.518.518 0 0 0-.724.384l-.982 6.656a3.974 3.974 0 0 0-2.426-.319c-.83.167-1.386.629-1.528 1.293-.113.635.022 1.214.39 1.674.699.873 1.975.994 2.153 1.007l.106.002c.933 0 2.424-.403 2.744-2.887l.87-5.89.12.075A1.564 1.564 0 0 0 16.1 5.09l.129-.127c-.032-.033-1.35-1.033-2.775-1.656"
})));

export { musicAndArtsIcon as default };
//# sourceMappingURL=musicAndArtsIcon.js.map
